<template>
  <v-navigation-drawer
    v-model="ui.rightDrawer"
    temporary
    location="right"
  >
    <v-list>
      <v-list-item avatar>
        <template #prepend>
          <OpAvatar
            :profile="login.profile"
            :size="40"
          />
        </template>
        <v-list-item-title class="font-weight-medium">
          {{ login.profile.last_name }} {{ login.profile.first_name }}
        </v-list-item-title>
        <v-list-item-subtitle class="font-weight-medium">
          {{ login.profile.email }}
        </v-list-item-subtitle>
      </v-list-item>
    </v-list>
    <v-card-actions>
      <v-spacer />
      <ChangePasswordDialog />
      <v-btn
        color="secondary"
        flat
        size="large"
        @click="$router.push({name: 'Logout'})"
      >
        {{ $t('User.Logout') }}
      </v-btn>
    </v-card-actions>
    <v-divider />
    <v-card-actions>
      <v-spacer />
      <TermsLink color="grey" />
    </v-card-actions>
    <v-divider />
  </v-navigation-drawer>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ChangePasswordDialog from '@/components/dialogs/ChangePasswordDialog'
  import OpAvatar from '@/components/parts/OpAvatar'
  import TermsLink from '@/terms/TermsLink'

  export default {
    name: 'RightMenu',
    components: {
      TermsLink,
      OpAvatar,
      ChangePasswordDialog
    },
    computed: {
      ...mapGetters(['login', 'ui'])
    }
  }
</script>

<style scoped>

</style>
